<template lang="pug">
.objectPopup(v-show="open", :class='{rightPaneOpen: showDiscussion}')
  .overlay.doNotDesactiveOnClick(@click="closeModal")
  .title
    .right
      template(v-if="sharedObject && !error")
        i.fa.fa-globe(@click='togglePublish', role='button', :title='$t("sharedObjectViewer.titles.togglePublish")', :class='{"text-muted": !sharedObject.public}')
        i.fa.fa-user-plus(@click='openSharedObjectMembers', role='button', :title='$t("sharedObjectViewer.titles.toShareManager")')
        i.fa.fa-folder-open(@click='openInFolder', role='button', :title='$t("sharedObjectViewer.titles.openParentFolder")', v-if='sharedObject.kind == "file" || sharedObject.kind == "folder"')
        //- i.fa.fa-print(v-if='nodeIsPrintable(sharedObject)')
        a(v-if='nodeIsDownloadable(sharedObject) && downloadLinkIsReady', :href='downloadLinkUrl', :title='$t("sharedObjectViewer.titles.download")', download)
          i.fa.fa-download
      i.fa.fa-times(@click="closeModal", :title='$t("sharedObjectViewer.titles.close")', role='button')
    template(v-if="sharedObject")
      .left(v-if="hasCollection")
        a(@click='goToPrevious', style="padding-left: 0; padding-right: 0; cursor: pointer")
          i.fa.fa-chevron-left
        a(@click.stop='goToNext', style="padding-left: 10px; padding-right: 0; cursor: pointer")
          i.fa.fa-chevron-right
        a {{index + 1}} / {{collection.length}}
      vue-object-img(:object='sharedObject.group')
      .name {{sharedObject.name}}
  .contents.doNotDesactiveOnClick#objectPopupContents(ref='contents', @click.self="closeModal")
    .body(@click.self="closeModal")
      template(v-if="sharedObject")
        .inViewer(v-if="sharedObject.loading", @click.self="closeModal")
          div.text-center
            template(v-if="!error")
              i.fa.fa-refresh.fa-spin
              br
              | {{$t("globals.loading")}}
            .alert.alert-warning(v-if="error") {{$t('sharedObjectViewer.error')}} {{$t('sharedObjectViewer.haveYouAccess')}}
        .body-padding-top(v-else-if="sharedObject.kind == 'event'")
          accordion.eventsList(:injected="true", container="#objectPopupContents", @click.self="closeModal", :thresold="50")
            detailled-event(:event='sharedObject', :initial-active='true', :initial-stay-active='true', :injected='false')
        .body-padding-top(v-else-if="sharedObject.kind == 'poll'")
          accordion.pollsList(:injected="true", container="#objectPopupContents", @click.self="closeModal", :thresold="50")
            poll(:poll='sharedObject', :initial-active='true', :initial-stay-active='true', :injected='false')
        .body-padding-top(v-else-if="sharedObject.kind == 'conversation'")
          accordion.mailbox(:injected="true", container="#objectPopupContents", @click.self="closeModal", :thresold="50")
            conversation(:conversation='sharedObject', :initial-active='true', :initial-stay-active='true', :injected='false')
        template(v-else)
          .inViewer(@click.self="closeModal")
            template(v-if="!inQuotaOrder")
              .exceededQuota
                h1 
                  i.fa.fa-bell
                h1 {{$t("sharedObjectViewer.exceededQuota.title")}}
                p {{$t("sharedObjectViewer.exceededQuota.description1")}}
                p {{$t("sharedObjectViewer.exceededQuota.description2")}} 
                .alert.alert-success
                  p.bpadding(v-if='bestRange.price != 0') {{$t("sharedObjectViewer.exceededQuota.incitation", {price: bestRange.price, space: hrS(bestRange.space * 1024 * 1024)})}}
                  .btn.btn-success(@click="goToGroupAccount") {{$t("sharedObjectViewer.exceededQuota.button")}}
            template(v-else-if="sharedObject.deleted")
              .deletedFile
                .text-center
                  h1 
                    i.fa.fa-ban
                  h3 {{$t("sharedObjectViewer.deletedItem.title")}}
                  p {{$t("sharedObjectViewer.deletedItem.description")}}
            template(v-else)
              .imageView(v-if='nodeIsImage(sharedObject)', style='overflow: hidden')
                img(v-lazy='downloadLinkUrl', v-if="downloadLinkIsReady")
              .audioView(v-if='nodeIsAudio(sharedObject) && !error')
                audio(controls="controls", autoplay="autoplay", style="width: 100%", v-if="downloadLinkIsReady")
                  source(:src="downloadLinkUrl" type="audio/mp3", @error="setError")
                  | {{$t("sharedObjectViewer.errorRuntime")}}
              //-   vue-viewer-wave(:node='selectedNode')
              .pdfView(v-if='nodeIsPDF(sharedObject)')
                iframe(:src='downloadLinkUrl')
              .videoView(v-if='nodeIsYoutubeLink(sharedObject)')
                //- video(v-if='selectedNode.extension == "mp4"' controls autoplay="true")
                //-   source(:src="selectedNode | downloadLink(3)" type="video/mp4")
                iframe(v-if='nodeIsYoutubeLink(sharedObject)' allowfullscreen frameborder="0", :src="getNodeYoutubeLink(sharedObject) +'?rel=0&autoplay=1'")
              .linkView.text-center(v-if='nodeIsLink(sharedObject)')
                //- video(v-if='selectedNode.extension == "mp4"' controls autoplay="true")
                //-   source(:src="selectedNode | downloadLink(3)" type="video/mp4")
                a(v-if='nodeIsLink(sharedObject)', :href="sharedObject.url", target="_blank", rel="noreferrer")
                  i.fa.fa-link.fa-2x
                  br
                  | {{sharedObject.url}}
              .defaultView(v-if='!hasFileViewer || error')
                .alert.alert-warning(v-if="error") {{$t('sharedObjectViewer.error')}}
                | {{$t('sharedObjectViewer.noVisualisation')}}
                br
                a.btn(v-if='nodeIsDownloadable(sharedObject) && downloadLinkIsReady', :href='downloadLinkUrl', target='_blank') 
                  i.fa.fa-download
                  |  {{$t('sharedObjectViewer.download')}}
      template(v-if="!sharedObject")
        .inViewer
          .alert.alert-warning(v-if="error") {{$t('sharedObjectViewer.error')}} {{$t('sharedObjectViewer.haveYouAccess')}}

  .rightPane(v-if='showDiscussion')
    div(style='position: absolute; right: 15px; top: 20px; z-index: 1')
      router-link(:to="{query: {m: 'shared', k: 'conversation', i: sharedObject.conversation.id || sharedObject.conversation}}", v-if="sharedObject.conversation", style="color: black")
        i.fa.fa-expand
    conversation-on-shared-object(:shared-object='sharedObject')
    div(style="padding-bottom: 100px")
  a.btn.btn-default.fixedBottomRight(v-if='canShowDiscussion', @click='rightPaneOpen = !rightPaneOpen')
    i.fa.fa-comments(v-if='!showDiscussion')
    i.fa.fa-arrow-right(v-if='showDiscussion')
    .title {{$t("sharedObjectViewer.toggleConversation")}}

</template>
<script>
import modalsBus from '@/components/shared/ModalsBus'
import eventsBus from '@/components/shared/EventsBus'

import Accordion from '@/components/shared/Accordion/Accordion'
import DetailledEvent from '@/components/Events/DetailledEvent'
import Poll from '@/components/Polls/Poll'
import Conversation from '@/components/Conversations/Conversation'
import ConversationOnSharedObject from '@/components/Conversations/ConversationOnSharedObject'
import VueObjectImg from '@/components/shared/VueObjectImg'

import NodeMixin from '@/components/shared/NodeMixin'
import MousetrapManager from '@/components/shared/mousetrapManager'

import {hrS} from '@/components/shared/vue.globals'

import $ from 'jquery'
import _ from 'lodash'

export default {
  data () {
    return {
      sharedObject: null,
      open: false,
      rightPaneOpen: false,
      downloadLinkObject: null,
      error: false,
      collection: [],
      index: -1,
      prevQuery: {}
    }
  },
  components: {
    VueObjectImg,
    Accordion,
    DetailledEvent,
    ConversationOnSharedObject,
    Poll,
    Conversation
  },
  mixins: [NodeMixin],
  mounted () {
    modalsBus.onOpen((arg, object) => {
      if (arg === modalsBus.modals.OPEN_SHARED_OBJECT) {
        if (object.subject && object.collection) {
          this.setSharedObject(object.subject)
          this.setCollection(object.collection)
        } else {
          this.setSharedObject(object)
          this.setCollection([])
        }
        this.openModal()
      } else {
        if (arg !== modalsBus.modals.EDIT_ANSWER) {
          this.closeModal()
        }
      }
    })
    modalsBus.onCloseAll(() => {
      this.closeModal()
    })
    eventsBus.$on(eventsBus.DELETED_EVENT, (data) => {
      if (this.sharedObject && this.sharedObject.kind === 'event' && this.sharedObject.id === data.event.id) {
        this.closeModal()
      }
    })
    this.checkOpenModalFromRouteQuery()
  },
  computed: {
    hasFileViewer () {
      return this.nodeIsImage(this.sharedObject) || this.nodeIsYoutubeLink(this.sharedObject) || this.nodeIsLink(this.sharedObject) || this.nodeIsAudio(this.sharedObject) || this.nodeIsPDF(this.sharedObject) || this.sharedObject.kind === 'event' || this.sharedObject.kind === 'poll'
    },
    showDiscussion () {
      return this.canShowDiscussion && this.rightPaneOpen
    },
    canShowDiscussion () {
      return this.sharedObject && this.sharedObject.kind !== 'event' && this.sharedObject.kind !== 'poll' && this.sharedObject.kind !== 'conversation' && !this.sharedObject.loading
    },
    downloadLinkUrl () {
      return this.downloadLinkObject.url
    },
    downloadLinkIsReady () {
      return this.downloadLinkObject.isReady
    },
    hasCollection () {
      return this.collection.length > 0
    },
    bestRange () {
      return this.$store.getters['files/goodRangeForSpace'](this.group.storageSize)
    },
    group () {
      if (this.sharedObject.kind === 'conversation') {
        return {id: -1}
      }
      if (!this.sharedObject.group) {
        return {id: -1, inQuotaOrder: true}
      }
      let fn = this.$store.getters['groops/getGroupWithId']
      return fn(this.sharedObject.group.id)
    },
    inQuotaOrder () {
      return !this.group || this.group.inQuotaOrder
    }
  },
  methods: {
    openSharedObjectMembers () {
      modalsBus.open(modalsBus.modals.MANAGE_RESTRICTED_VIEWERS, this.sharedObject)
    },
    setSharedObject (object) {
      this.error = false
      this.sharedObject = object
      this.downloadLinkObject = this.downloadLinkReactive(this.sharedObject, 3)
    },
    setCollection (collection) {
      this.collection = collection
      this.index = this.collection.indexOf(this.sharedObject)
      if (this.collection.length > 0 && this.index === -1) {
        this.index = 0
      }
    },
    goToNext () {
      this.index = (this.index + 1) % this.collection.length
    },
    goToPrevious () {
      this.index = (this.index - 1 + this.collection.length) % this.collection.length
    },
    installKeyshorts () {
      MousetrapManager.bindAll({
        'k': () => {
          this.goToNext()
        },
        'right': () => {
          this.goToNext()
        },
        'j': () => {
          this.goToPrevious()
        },
        'left': () => {
          this.goToPrevious()
        },
        'esc': () => {
          this.closeModal()
        }
      }, 'SharedObjectViewer')
    },
    openModal () {
      if (this.open) {
        return
      }
      if (this.$route.query.m !== 'shared') {
        this.prevQuery = this.$route.query
      } else {
        this.prevQuery = {}
      }
      if (this.sharedObject.kind !== 'deleted') {
        if (this.$route.query.m !== 'shared' || this.$route.query.k !== this.sharedObject.kind || this.$route.query.i !== this.sharedObject.id) {
          this.$router.push({query: _.merge({}, this.prevQuery, {m: 'shared', k: this.sharedObject.kind, i: this.sharedObject.id})})
        }
      }
      this.unwatch = this.$watch('sharedObject', () => {
        if (this.sharedObject && this.sharedObject.kind !== 'deleted') {
          if (this.$route.query.m !== 'shared' || this.$route.query.k !== this.sharedObject.kind || this.$route.query.i !== this.sharedObject.id) {
            this.$router.push({query: _.merge({}, this.prevQuery, {m: 'shared', k: this.sharedObject.kind, i: this.sharedObject.id})})
          }
        }
      })
      this.open = true
      this.installKeyshorts()
      this.$nextTick(() => {
        if (this.$refs.contents) {
          this.$refs.contents.scrollTop = 0
        }
        if ($(window).width() >= 1200) {
          this.rightPaneOpen = true
        } else {
          this.rightPaneOpen = false
        }
      })
    },
    closeModal () {
      if (!this.open) {
        return
      }
      this.$router.push({query: this.prevQuery})
      MousetrapManager.unbindLabel('SharedObjectViewer')
      this.open = false
      this.rightPaneOpen = false
      this.sharedObject = null
      if (this.unwatch) {
        this.unwatch()
      }
    },
    openInFolder () {
      this.$router.push({name: 'Nodes', params: {type: 'folder', id: this.sharedObject.parent.id, selectNode: this.sharedObject}})
    },
    togglePublish () {
      this.$store.dispatch('sharedObjects/togglePublish', this.sharedObject)
    },
    setError () {
      this.error = true
    },
    goToGroupAccount () {
      modalsBus.open(modalsBus.modals.OPEN_GROUP_ACCOUNT, this.group)
    },
    checkOpenModalFromRouteQuery () {
      let kind = this.$route.query.k
      let id = parseInt(this.$route.query.i)
      if (this.$route.query.m === 'shared') {
        // same open object ?
        if (this.sharedObject && kind === this.sharedObject.kind && id === this.sharedObject.id) {
          // console.log('shared')
          // this.openModal()
          return
        }
        this.setCollection([])
        let promise = this.$store.dispatch('sharedObjects/loadSharedObject', {kind, id})
        if (promise) {
          this.setSharedObject({
            kind: kind,
            id: id,
            loading: true
          })
          this.openModal()
          promise.then((object) => {
            this.setSharedObject(object)
          }).catch(() => {
            this.setError()
          })
        } else {
          this.setError()
        }
      } else {
        this.closeModal()
      }
    }
  },
  watch: {
    index () {
      if (this.collection.length === 0 || this.index === -1) {
        return
      }
      this.setSharedObject(this.collection[this.index])
    },
    $route () {
      this.checkOpenModalFromRouteQuery()
    }
  },
  filters: {
    hrS
  }
}
</script>
<style lang="sass" scoped>
@import "../../assets/css/variables"
$color1: #3D4F5D

$rightPaneWidth: 400px

@mixin vendor-prefix($name, $argument)
  -webkit-#{$name}: #{$argument}
  -ms-#{$name}: #{$argument}
  -moz-#{$name}: #{$argument}
  -o-#{$name}: #{$argument}
  #{$name}: #{$argument}


.objectPopup
  position: fixed
  top: 0
  left: 0
  right: 0
  bottom: 0
  z-index: $indexViewer
  .body-padding-top
    padding-top: 50px
  .inViewer
    height: 100%
    @include vendor-prefix("transition", "width 0.5s ease, height 0.5s ease, margin-right 0.5s ease, max-width 0.5s ease")
    & > *
      padding: 20px
      width: 600px
      margin-left: auto
      margin-right: auto
      max-height: calc(100% - 80px)
      @include vendor-prefix("transition", "width 0.5s ease, height 0.5s ease, margin-right 0.5s ease, max-width 0.5s ease")
      background-color: white
      overflow: auto
      max-width: calc(100% - 40px)
      border-radius: 5px
      margin-top: 70px
      pointer-events: auto
      @include vendor-prefix("transform-origin", "0 0")
      // @include vendor-prefix("transition", "transform 0.5s ease")
  .fixedBottomRight
    transition: right 0.5s ease
    z-index: $indexViewer + 2
  &.rightPaneOpen 
    .inViewer
      @media(min-width: #{$rightPaneWidth + 300})
        max-width: calc(100% - #{$rightPaneWidth})
        margin-right: $rightPaneWidth
    .fixedBottomRight
      @media(min-width: #{$rightPaneWidth + 300})
        right: calc(#{$rightPaneWidth} - 30px)
  .mailbox
    margin-top: 20px
    .audioTime
      cursor: pointer
    .pdfPage
      cursor: pointer
  .defaultView
    text-align: center
    @include vendor-prefix("box-shadow", "0px 0px 16px 0px rgba(50, 50, 50, 0.75)")
  
  .textView
    font-size: 12px
    font-family: monospace
    width: calc(100% - 40px)
    @include vendor-prefix("box-shadow", "0px 0px 16px 0px rgba(50, 50, 50, 0.75)")
  
  .imageView
    width: calc(100% - 40px)
    text-align: center
    background: transparent
    overflow: hidden
    border: 0
    pointer-events: none
    width: auto
    height: 100%
    padding: 0
    border-radius: 0
    img
      pointer-events: auto
      max-width: 100%
      max-height: 100%
      @include vendor-prefix("box-shadow", "0px 0px 16px 0px rgba(50, 50, 50, 0.75)")

  .audioView
    .error
      text-align: center
    position: relative    
    @include vendor-prefix("box-shadow", "0px 0px 16px 0px rgba(50, 50, 50, 0.75)")
    .time
      float: right
    .loading
      position: absolute
      top: 50px
      left: 50%
      transform: translateX(-50%)
      font-size: 20px
    & > a
      color: #333
      cursor: pointer
      font-size: 20px 
  .videoView
    text-align: center
    background: transparent
    overflow: hidden
    border: 0
    width: calc(100% - 80px)
    height: calc(100% - 110px)
    padding: 0
    border-radius: 0
    background-color: black
    @include vendor-prefix("box-shadow", "0px 0px 16px 0px rgba(50, 50, 50, 0.75)")
    position: relative
    video, iframe
      position: absolute
      border: 0
      top: 0
      left: 0
      width: 100%
      height: 100%
  .exceededQuota
    text-align: center
    h1 i
      -webkit-animation: ring 4s .7s ease-in-out infinite;
      -webkit-transform-origin: 50% 4px;
      -moz-animation: ring 4s .7s ease-in-out infinite;
      -moz-transform-origin: 50% 4px;
      animation: ring 4s .7s ease-in-out infinite;
      transform-origin: 50% 4px;
      
  .pdfView
    width: calc(100% - 20px)
    max-width: 1000px
    min-height: calc(100% - 10px)
    position: relative
    padding: 0
    @include vendor-prefix("box-shadow", "0px 0px 16px 0px rgba(50, 50, 50, 0.75)")
    iframe
      position: absolute
      border: 0
      width: 100%
      height: 100%
  .nextPrev
    width: 100%
    height: 100%
    position: fixed
    pointer-events: none
    opacity: 0
    z-index: 5000
    .next, .prev
      position: absolute
      top: 50%
      transform: translateX(-50%) translateY(-50%)
      color: white
      font-size: 20px
      background-color: black
      width: 50px
      height: 50px
      line-height: 50px
      border-radius: 50%
      text-align: center
    &.taken 
      .next, .prev
        background-color: white
        color: black
    .next
      right: -30px
    .prev
      left: -30px
  .rightPane
    position: absolute
    top: 50px
    @media(max-width: 468px)
      top: 75px
    background-color: rgba(0,0,0,0.8)
    right: 0
    max-width: $rightPaneWidth
    width: 100%
    bottom: 0
    overflow: auto
    z-index: $indexViewer + 1
    .mailbox
      margin-top: 0px
    .object-info
      color: #DDD
      padding-left: 10px
      padding-right: 10px
      .profileImage
        width: 50px
        height: 50px
        margin-right: 10px
        line-height: 50px
        vertical-align: top
      table
        td
          padding: 5px
          vertical-align: top
          &:first-child
            width: 110px
  
  .menuBar
    position: fixed
    background-color: rgba(0,0,0, 1)
    z-index: 3000
    width: 100%
    white-space: nowrap

    .previousBtn, .nextBtn, .closeBtn, .printBtn, .zoomDiv, .downloadBtn, .information, .openInNodeView
      pointer-events: auto
      float: left
      color: white
      cursor: pointer
      margin: 5px
      line-height: 50px
    
    .previousBtn
      margin-left: 10px
    
    .closeBtn
      float: right
      margin: 5px
      margin-right: 10px
    
    .printBtn, .zoomDiv, .downloadBtn, .information, .openInNodeView
      float: right
      padding-left: 10px
      padding-right: 10px
    
    .zoomDiv
      position: relative
    
    .nameLabel
      color: white
      font-weight: bold
      width: 100%
      text-align: center
      line-height: 60px
      white-space: nowrap
      max-width: calc(100% - 300px)
      overflow: hidden
      text-overflow: ellipsis
    
    .indexLabel
      color: rgba(255,255,255,0.7)
      float: left
      margin: 5px
      margin-right: 10px
      line-height: 50px
      font-size: 12px
    
    .zoomBar
      -webkit-appearance: slider-vertical
      appearance: slider-vertical
      width: 10px
      height: 90px
      position: absolute
      top: 35px
      right: 10px
      opacity: 0
      pointer-events: none
    
    .zoomDiv:hover .zoomBar
      opacity: 1
      pointer-events: auto
    

#body.viewerOpen
  overflow: hidden!important
</style>



// WEBPACK FOOTER //
// SharedObjectViewer.vue?cbe107a4